export default __webpack_public_path__ + "static/media/retakeYono@2x.21bf92ef.png";